/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

export * from 'SourceUtil/Address';
/** @namespace Bookland/Util/Address/Index/trimPrefixAddress */
export const trimPrefixAddress = (address, prefix = '') => {
    const street = [];

    const addressWithoutPrefix = Object.fromEntries(
        Object.entries(address).filter(([key]) => key.includes(`${prefix}-`)).map(([key, value]) => {
            const trimmedKey = key.replace(`${prefix}-`, '');

            if (trimmedKey.includes('street_')) {
                street.push(value);
            }

            return ([trimmedKey, value]);
        })
    );

    const {
        company = null,
        city = '',
        country_id = 'PL',
        firstname = '',
        lastname = '',
        postcode = '',
        telephone = '',
        region_string = '',
        region_id = 0,
        region_code = null,
        vat_id = null
    } = addressWithoutPrefix;

    return {
        company,
        city,
        country_id,
        firstname,
        lastname,
        postcode,
        street,
        telephone,
        region: region_string,
        region_id: region_id === '' ? 0 : region_id,
        region_code,
        vat_id
    };
};
